import {
  createLocalStorage,
  LocalPersistentStorage,
} from '@webapp/core/services/LocalPersistentStorage'
import { ChangelogApiClient } from '@webapp/platform/discover-more/data-access/clients/ChangelogApiClient'
import { ChangelogRepository } from './ChangelogRepository'

export const changelogRepository = new ChangelogRepository({
  httpClient: ChangelogApiClient,
  // A week-old release list still beats an empty promo spot; past that the
  // surface falls back to its non-changelog content.
  persistentStorage: createLocalStorage({
    defaultTTL: LocalPersistentStorage.DEFAULT_TTL.WEEK,
  }),
})

export { ChangelogRepository }
